/**
 * Homepage: gender category rows (native scroll) + featured collections (Flickity tabs).
 */
(function () {
  var GENDER_SECTION = '[data-sk-collection-gender]';
  var FLICKITY_SECTION = '[data-sk-featured-collections]';
  var GENDER_PANEL = '[data-sk-gender-panel]';
  var FEATURED_PANEL = '[data-sk-featured-panel]';

  /* ==========================================================================
     Gender collection tabs — horizontal scroll (no Flickity)
     ========================================================================== */

  function getGenderActivePanel(section) {
    return (
      section.querySelector(GENDER_PANEL + '.is-active') ||
      section.querySelector(GENDER_PANEL + ':not([hidden])')
    );
  }

  function getGenderActiveTrack(section) {
    var panel = getGenderActivePanel(section);
    return panel ? panel.querySelector('[data-sk-gender-scroll]') : null;
  }

  function getGenderVisibleCols() {
    var w = window.innerWidth;
    if (w >= 1008) return 3;
    if (w >= 641) return 2;
    return 1;
  }

  function getGenderScrollStep(track) {
    var firstItem = track.querySelector('.CollectionItem');
    if (!firstItem) return Math.max(track.clientWidth, 1);
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 12;
    return firstItem.getBoundingClientRect().width + gap;
  }

  function updateGenderScrollNav(section) {
    var track = getGenderActiveTrack(section);
    var prevBtns = section.querySelectorAll('[data-sk-carousel-prev]');
    var nextBtns = section.querySelectorAll('[data-sk-carousel-next]');
    if (!prevBtns.length || !nextBtns.length) return;

    var prevDisabled = true;
    var nextDisabled = true;

    if (track && track.scrollWidth > track.clientWidth + 1) {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var tol = 4;
      prevDisabled = track.scrollLeft <= tol;
      nextDisabled = track.scrollLeft >= maxScroll - tol;
    }

    prevBtns.forEach(function (btn) {
      btn.disabled = prevDisabled;
    });
    nextBtns.forEach(function (btn) {
      btn.disabled = nextDisabled;
    });
  }

  function scrollGenderTrack(section, direction) {
    var track = getGenderActiveTrack(section);
    if (!track) return;

    var step = getGenderScrollStep(track) * getGenderVisibleCols();
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function bindGenderNav(section) {
    section.querySelectorAll('[data-sk-carousel-nav]').forEach(function (nav) {
      var prevBtn = nav.querySelector('[data-sk-carousel-prev]');
      var nextBtn = nav.querySelector('[data-sk-carousel-next]');
      if (!prevBtn || !nextBtn || prevBtn.dataset.skGenderNavBound === 'true') return;

      prevBtn.dataset.skGenderNavBound = 'true';
      nextBtn.dataset.skGenderNavBound = 'true';

      prevBtn.addEventListener('click', function () {
        scrollGenderTrack(section, -1);
      });

      nextBtn.addEventListener('click', function () {
        scrollGenderTrack(section, 1);
      });
    });
  }

  function switchGenderTab(section, tab) {
    if (tab.classList.contains('is-active')) return;

    var panelId = tab.getAttribute('aria-controls');
    var panel = section.querySelector('#' + panelId);
    if (!panel) return;

    section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll(GENDER_PANEL).forEach(function (p) {
      var show = p === panel;
      p.setAttribute('aria-hidden', show ? 'false' : 'true');
      p.hidden = !show;
      p.classList.toggle('is-active', show);

      if (show) {
        var track = p.querySelector('[data-sk-gender-scroll]');
        if (track) track.scrollLeft = 0;
      }
    });

    window.requestAnimationFrame(function () {
      updateGenderScrollNav(section);
    });
  }

  function initGenderScrollSections(scope) {
    var root = scope || document;
    root.querySelectorAll(GENDER_SECTION).forEach(function (section) {
      if (section.dataset.skGenderInit === 'true') return;
      section.dataset.skGenderInit = 'true';

      bindGenderNav(section);

      section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (tab) {
        tab.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            switchGenderTab(section, tab);
          },
          true
        );
      });

      section.querySelectorAll('[data-sk-gender-scroll]').forEach(function (track) {
        if (track.dataset.skScrollBound === 'true') return;
        track.dataset.skScrollBound = 'true';
        track.addEventListener(
          'scroll',
          function () {
            if (getGenderActiveTrack(section) === track) {
              updateGenderScrollNav(section);
            }
          },
          { passive: true }
        );
      });

      updateGenderScrollNav(section);
    });
  }

  function onGenderScrollResize() {
    document.querySelectorAll(GENDER_SECTION).forEach(updateGenderScrollNav);
  }

  /* ==========================================================================
     Featured collections — Flickity tabbed carousels
     ========================================================================== */

  function parseFlickityConfig(el) {
    var raw = el.getAttribute('data-flickity-config');
    if (!raw) return {};
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {};
    }
  }

  function getFlickity(el) {
    if (typeof Flickity === 'undefined' || !el) return null;
    return Flickity.data(el);
  }

  function initCarousel(el) {
    if (!el || typeof Flickity === 'undefined') return null;
    if (el.classList.contains('flickity-enabled')) return getFlickity(el);
    return new Flickity(el, parseFlickityConfig(el));
  }

  function getFeaturedActivePanel(section) {
    return (
      section.querySelector(FEATURED_PANEL + '.is-active') ||
      section.querySelector(FEATURED_PANEL + ':not([hidden])')
    );
  }

  function getFeaturedActiveCarouselEl(section) {
    var panel = getFeaturedActivePanel(section);
    return panel ? panel.querySelector('[data-flickity-config]') : null;
  }

  function getSlideCount(flk) {
    if (!flk) return 0;
    if (flk.slides && flk.slides.length) return flk.slides.length;
    return flk.cells ? flk.cells.length : 0;
  }

  function canGoPrev(flk) {
    if (!flk || !getSlideCount(flk)) return false;
    if (flk.options.wrapAround) return true;
    return flk.selectedIndex > 0;
  }

  function canGoNext(flk) {
    if (!flk || !getSlideCount(flk)) return false;
    if (flk.options.wrapAround) return true;
    return flk.selectedIndex < getSlideCount(flk) - 1;
  }

  function updateFeaturedNav(section) {
    var prevBtns = section.querySelectorAll('[data-sk-carousel-prev]');
    var nextBtns = section.querySelectorAll('[data-sk-carousel-next]');
    if (!prevBtns.length || !nextBtns.length) return;

    var flk = getFlickity(getFeaturedActiveCarouselEl(section));
    var prevDisabled = !canGoPrev(flk);
    var nextDisabled = !canGoNext(flk);

    prevBtns.forEach(function (btn) {
      btn.disabled = prevDisabled;
    });
    nextBtns.forEach(function (btn) {
      btn.disabled = nextDisabled;
    });
  }

  function onFeaturedCarouselSelect(section, el) {
    var flk = getFlickity(el);
    adjustFeaturedTailAlign(el, flk);
    updateFeaturedNav(section);
  }

  function attachFeaturedNavListener(section, el) {
    var flk = getFlickity(el);
    if (!flk || flk._skTabbedNavBound) return;
    flk._skTabbedNavBound = true;
    flk.on('select', function () {
      onFeaturedCarouselSelect(section, el);
    });
    flk.on('settle', function () {
      adjustFeaturedTailAlign(el, flk);
      updateFeaturedNav(section);
    });
  }

  function bindFeaturedNav(section) {
    section.querySelectorAll('[data-sk-carousel-nav]').forEach(function (nav) {
      var prevBtn = nav.querySelector('[data-sk-carousel-prev]');
      var nextBtn = nav.querySelector('[data-sk-carousel-next]');
      if (!prevBtn || !nextBtn || prevBtn.dataset.skFeaturedNavBound === 'true') return;

      prevBtn.dataset.skFeaturedNavBound = 'true';
      nextBtn.dataset.skFeaturedNavBound = 'true';

      prevBtn.addEventListener('click', function () {
        var flk = getFlickity(getFeaturedActiveCarouselEl(section));
        if (flk) flk.previous();
      });

      nextBtn.addEventListener('click', function () {
        var flk = getFlickity(getFeaturedActiveCarouselEl(section));
        if (flk) flk.next();
      });
    });
  }

  function getFeaturedVisibleCols() {
    var w = window.innerWidth;
    if (w >= 1140) return 4;
    if (w >= 1008) return 3;
    return 2;
  }

  function adjustFeaturedTailAlign(el, flk) {
    if (!el || !flk || !flk.cells || !flk.cells.length) return;

    el.classList.remove('is-tail-centered');

    var cols = getFeaturedVisibleCols();
    var remainder = flk.cells.length % cols;
    if (!remainder || !flk.slides || !flk.slides.length) return;
    if (flk.selectedIndex !== flk.slides.length - 1) return;

    var slide = flk.slides[flk.slides.length - 1];
    if (!slide || !slide.cells.length) return;

    el.classList.add('is-tail-centered');

    var viewport = flk.size.innerWidth;
    var groupLeft = slide.cells[0].target;
    var lastCell = slide.cells[slide.cells.length - 1];
    var groupWidth = lastCell.target + lastCell.size.outerWidth - groupLeft;
    var centeredX = -groupLeft + (viewport - groupWidth) / 2;

    flk.x = Math.min(0, centeredX);
    flk.positionSlider();
  }

  function syncFeaturedCarousel(section, el) {
    var flk = getFlickity(el);
    if (!flk) return;

    var groupCells = getFeaturedVisibleCols();
    var needsReload = flk.options.groupCells !== groupCells;

    if (flk.options.contain !== true) {
      flk.options.contain = true;
      needsReload = true;
    }

    if (needsReload) {
      flk.options.groupCells = groupCells;
      flk.reloadCells();
    }

    flk.resize();
    adjustFeaturedTailAlign(el, flk);
    updateFeaturedNav(section);
  }

  function setupFeaturedCarousel(section, el) {
    if (!el) return;
    var panel = el.closest(FEATURED_PANEL);
    if (panel && panel.hidden) return;

    initCarousel(el);
    syncFeaturedCarousel(section, el);
    attachFeaturedNavListener(section, el);
    updateFeaturedNav(section);
  }

  function switchFeaturedTab(section, tab) {
    if (tab.classList.contains('is-active')) return;

    var panelId = tab.getAttribute('aria-controls');
    var panel = section.querySelector('#' + panelId);
    if (!panel) return;

    section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (btn) {
      var active = btn === tab;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    section.querySelectorAll(FEATURED_PANEL).forEach(function (p) {
      var show = p === panel;
      p.setAttribute('aria-hidden', show ? 'false' : 'true');
      p.hidden = !show;
      p.classList.toggle('is-active', show);

      if (show) {
        var carouselEl = p.querySelector('[data-flickity-config]');
        window.requestAnimationFrame(function () {
          setupFeaturedCarousel(section, carouselEl);
        });
      }
    });
  }

  function initFeaturedCarousels(scope) {
    var root = scope || document;
    root.querySelectorAll(FLICKITY_SECTION).forEach(function (section) {
      if (section.dataset.skFeaturedInit === 'true') return;
      section.dataset.skFeaturedInit = 'true';

      bindFeaturedNav(section);

      section.querySelectorAll('[data-action="toggle-tab"]').forEach(function (tab) {
        tab.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            switchFeaturedTab(section, tab);
          },
          true
        );
      });

      section.querySelectorAll('[data-flickity-config]').forEach(function (el) {
        attachFeaturedNavListener(section, el);
      });

      window.requestAnimationFrame(function () {
        setupFeaturedCarousel(section, getFeaturedActiveCarouselEl(section));
      });
    });
  }

  function destroyFeaturedCarousels(scope) {
    var root = scope || document;
    if (typeof Flickity === 'undefined') return;

    root.querySelectorAll(FLICKITY_SECTION + ' [data-flickity-config].flickity-enabled').forEach(function (el) {
      var instance = Flickity.data(el);
      if (instance) instance.destroy();
    });
  }

  /* ==========================================================================
     Scroll reveal
     ========================================================================== */

  function initSkReveal(scope) {
    var root = scope || document;
    var elements = root.querySelectorAll('[data-sk-reveal]:not([data-sk-reveal-init])');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
        el.setAttribute('data-sk-reveal-init', 'true');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.intersectionRatio <= 0) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -32px 0px' }
    );

    elements.forEach(function (el) {
      el.setAttribute('data-sk-reveal-init', 'true');
      observer.observe(el);
    });
  }

  /* ==========================================================================
     Collage — kadraj / odak noktası
     ========================================================================== */

  var COLLAGE_PRODUCT_HANDLES = {
    'mini-fular': true
  };

  var COLLAGE_FOCAL_OVERRIDES = {
    'cotton-fular': 'right center',
    'kadin-gomlek': 'center 12%',
    sapka: 'center 12%',
    scrunchie: 'center 42%'
  };

  var COLLAGE_RESPONSIVE_HANDLES = {
    'sal-pareo': true
  };

  function getCollageCardHandle(card) {
    if (!card || !card.classList) return '';

    for (var i = 0; i < card.classList.length; i++) {
      var part = card.classList[i].slice('SkCollageHero__card--'.length);

      if (!part || part === card.classList[i]) continue;
      if (/^(hero|tall|wide|medium|small|s\d+)$/.test(part)) continue;
      return part;
    }

    return '';
  }

  function fitCollageFocal(img) {
    if (!img.naturalWidth) return;

    var card = img.closest('.SkCollageHero__card');
    if (!card || card.classList.contains('SkCollageHero__card--esarp')) return;

    var handle = getCollageCardHandle(card);

    if (COLLAGE_RESPONSIVE_HANDLES[handle]) {
      img.style.objectPosition = '';
      img.style.transform = '';
      return;
    }

    var box = img.parentElement;
    if (box && box.tagName === 'PICTURE') {
      box = card.querySelector('.SkCollageHero__photo');
    }
    if (!box) return;

    var cw = box.clientWidth;
    var ch = box.clientHeight;
    if (!cw || !ch) return;

    img.style.objectPosition = '';
    img.style.transform = '';

    if (COLLAGE_FOCAL_OVERRIDES[handle]) {
      img.style.objectPosition = COLLAGE_FOCAL_OVERRIDES[handle];
      return;
    }

    if (COLLAGE_PRODUCT_HANDLES[handle]) {
      img.style.objectPosition = 'center center';
      return;
    }

    var imageRatio = img.naturalWidth / img.naturalHeight;
    var boxRatio = cw / ch;

    if (imageRatio < boxRatio * 0.9) {
      img.style.objectPosition = 'center top';
      return;
    }

    if (imageRatio > boxRatio * 1.15) {
      img.style.objectPosition = 'center center';
      return;
    }

    img.style.objectPosition = 'center 22%';
  }

  function initCollageFocalImages(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;

    root
      .querySelectorAll('.SkCollageHero__card:not(.SkCollageHero__card--esarp) .SkCollageHero__photo img')
      .forEach(function (img) {
        function run() {
          fitCollageFocal(img);
        }

        if (img.complete && img.naturalWidth) run();
        else img.addEventListener('load', run, { once: true });
      });
  }

  /* ==========================================================================
     Collage — eşarp: tam görsel, yan boşluk yok
     ========================================================================== */

  function fitEsarpCollageImage(img) {
    if (!img.naturalWidth) return;

    var box = img.parentElement;
    if (!box) return;

    var cw = box.clientWidth;
    var ch = box.clientHeight;
    if (!cw || !ch) return;

    var imageRatio = img.naturalWidth / img.naturalHeight;
    var fitWidthAtFullHeight = ch * imageRatio;

    img.style.transform = '';
    img.style.margin = '';
    img.style.maxWidth = '';
    img.style.maxHeight = '';

    if (fitWidthAtFullHeight >= cw) {
      img.style.width = 'auto';
      img.style.height = '100%';
      img.style.maxWidth = '100%';
      return;
    }

    img.style.width = '100%';
    img.style.height = 'auto';
  }

  function initEsarpCollageImages(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;

    root.querySelectorAll('.SkCollageHero__card--esarp .SkCollageHero__photo img').forEach(function (img) {
      function run() {
        fitEsarpCollageImage(img);
      }

      if (img.complete && img.naturalWidth) run();
      else img.addEventListener('load', run, { once: true });
    });
  }

  /* ==========================================================================
     Background video — clean loop, no YouTube chrome
     ========================================================================== */

  var BACKGROUND_VIDEO_SECTION = '[data-section-type="background-video"]';

  function startYouTubeLoopGuard(player) {
    return window.setInterval(function () {
      try {
        if (!player || typeof player.getCurrentTime !== 'function') return;

        var duration = player.getDuration();
        var currentTime = player.getCurrentTime();
        var playerState = typeof player.getPlayerState === 'function' ? player.getPlayerState() : null;

        if (window.YT && playerState === window.YT.PlayerState.ENDED) {
          player.seekTo(0, true);
          player.playVideo();
          return;
        }

        if (
          playerState === window.YT.PlayerState.PLAYING &&
          duration > 8 &&
          currentTime > 1 &&
          currentTime / duration >= 0.88
        ) {
          player.seekTo(0, true);
          player.playVideo();
        }
      } catch (error) {
        /* noop */
      }
    }, 150);
  }

  function loadYouTubeApi() {
    return new Promise(function (resolve) {
      if (window.YT && window.YT.Player) {
        resolve();
        return;
      }

      var previousReady = window.onYouTubeIframeAPIReady;

      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === 'function') {
          previousReady();
        }

        resolve();
      };

      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.body.appendChild(script);
        return;
      }

      var attempts = 0;
      var poll = window.setInterval(function () {
        attempts += 1;

        if (window.YT && window.YT.Player) {
          window.clearInterval(poll);
          resolve();
        } else if (attempts > 50) {
          window.clearInterval(poll);
          resolve();
        }
      }, 100);
    });
  }

  function getBackgroundVideoPlayer(holder) {
    if (!holder || !holder.id || !window.YT || typeof window.YT.get !== 'function') {
      return null;
    }

    return window.YT.get(holder.id);
  }

  function mountBackgroundVideoPlayer(section, settings, holder) {
    if (!holder || section.dataset.skVideoMounted === 'true') return;

    section.dataset.skVideoMounted = 'true';

    section._skBackgroundPlayer = new window.YT.Player(holder, {
      host: 'https://www.youtube-nocookie.com',
      videoId: settings.videoId,
      playerVars: {
        autoplay: 1,
        mute: 1,
        showinfo: 0,
        controls: 0,
        fs: 0,
        rel: 0,
        iv_load_policy: 3,
        cc_load_policy: 0,
        html5: 1,
        loop: 1,
        playlist: settings.videoId,
        playsinline: 1,
        modestbranding: 1,
        disablekb: 1,
        autohide: 1,
        origin: window.location.origin
      },
      events: {
        onReady: function (event) {
          event.target.mute();
          event.target.playVideo();
          section._skLoopGuardInterval = startYouTubeLoopGuard(event.target);
        },
        onStateChange: function (event) {
          if (event.data === window.YT.PlayerState.ENDED) {
            event.target.seekTo(0, true);
            event.target.playVideo();
          }
        }
      }
    });
  }

  function resetBackgroundVideoPlayer(section, settings, holder) {
    var existingPlayer = getBackgroundVideoPlayer(holder);

    if (existingPlayer && typeof existingPlayer.destroy === 'function') {
      try {
        existingPlayer.destroy();
      } catch (error) {
        /* noop */
      }
    }

    holder.innerHTML = '';
    delete section.dataset.skVideoMounted;

    if (section._skLoopGuardInterval) {
      window.clearInterval(section._skLoopGuardInterval);
      section._skLoopGuardInterval = null;
    }

    mountBackgroundVideoPlayer(section, settings, holder);
  }

  function initBackgroundVideoGuard(section) {
    if (!section || section.dataset.skVideoGuardInit === 'true') return;

    var settings;

    try {
      settings = JSON.parse(section.getAttribute('data-section-settings'));
    } catch (error) {
      return;
    }

    if (!settings || settings.videoType !== 'youtube') return;

    var holder = section.querySelector('.ImageHero__VideoHolder');
    if (!holder) return;

    loadYouTubeApi().then(function () {
      if (section.dataset.skVideoGuardInit === 'true') return;

      var attempts = 0;
      var poll = window.setInterval(function () {
        attempts += 1;
        var player = getBackgroundVideoPlayer(holder);

        if (player && typeof player.getCurrentTime === 'function') {
          window.clearInterval(poll);
          section.dataset.skVideoGuardInit = 'true';
          section._skLoopGuardInterval = startYouTubeLoopGuard(player);

          window.setTimeout(function () {
            var state = typeof player.getPlayerState === 'function' ? player.getPlayerState() : null;

            if (
              state === window.YT.PlayerState.UNSTARTED ||
              state === window.YT.PlayerState.CUED ||
              state === window.YT.PlayerState.ENDED
            ) {
              resetBackgroundVideoPlayer(section, settings, holder);
            }
          }, 4000);

          return;
        }

        if (attempts >= 24) {
          window.clearInterval(poll);
          section.dataset.skVideoGuardInit = 'true';
          mountBackgroundVideoPlayer(section, settings, holder);
        }
      }, 250);
    });
  }

  function destroyBackgroundVideoGuard(section) {
    if (section._skLoopGuardInterval) {
      window.clearInterval(section._skLoopGuardInterval);
      section._skLoopGuardInterval = null;
    }

    if (section._skBackgroundPlayer && typeof section._skBackgroundPlayer.destroy === 'function') {
      try {
        section._skBackgroundPlayer.destroy();
      } catch (error) {
        /* noop */
      }
    }

    delete section._skBackgroundPlayer;
    delete section.dataset.skVideoGuardInit;
    delete section.dataset.skVideoMounted;
  }

  function initBackgroundVideoGuards(scope) {
    var root = scope || document;
    if (!root.querySelectorAll) return;

    root.querySelectorAll(BACKGROUND_VIDEO_SECTION).forEach(initBackgroundVideoGuard);
  }

  /* ==========================================================================
     Bootstrap
     ========================================================================== */

  var resizeTimer;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      onGenderScrollResize();
      initEsarpCollageImages();
      initCollageFocalImages();
      document.querySelectorAll(FLICKITY_SECTION).forEach(function (section) {
        var el = getFeaturedActiveCarouselEl(section);
        if (el) syncFeaturedCarousel(section, el);
      });
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGenderScrollSections();
    initFeaturedCarousels();
    initSkReveal();
    initEsarpCollageImages();
    initCollageFocalImages();
    initBackgroundVideoGuards();
    window.addEventListener('resize', onResize);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initGenderScrollSections(event.target);
    initFeaturedCarousels(event.target);
    initSkReveal(event.target);
    initEsarpCollageImages(event.target);
    initCollageFocalImages(event.target);
    initBackgroundVideoGuards(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(BACKGROUND_VIDEO_SECTION).forEach(destroyBackgroundVideoGuard);
    event.target.querySelectorAll(GENDER_SECTION).forEach(function (section) {
      delete section.dataset.skGenderInit;
    });
    event.target.querySelectorAll(FLICKITY_SECTION).forEach(function (section) {
      delete section.dataset.skFeaturedInit;
    });
    destroyFeaturedCarousels(event.target);
  });
})();
